import React, {Fragment} from 'react'
import {Link} from 'react-router-dom'

import withSlider from '../hoc/with-slider'
import FavoriteHeart from '../favorite-heart'

const FeaturedSlider = ({index, handleArrowClick, updateSliderComponentData, updateSliderBackgrounds}) => {
  let
    previousProduct = updateSliderComponentData(index - 1),
    currentProduct = updateSliderComponentData(index),
    nextProduct = updateSliderComponentData(index + 1);

  return (
    <Fragment>
      <div className="new-deals__slider">
        <div className="new-deals__arrow new-deals__arrow_left arrow"
             onClick={handleArrowClick}>
        </div>
        <div className="new-deals__product new-deals__product_first"
             style={updateSliderBackgrounds(index - 1)}>
          <Link to={`/product-card-desktop/${previousProduct && previousProduct.id}`}/>
        </div>
        <div className="new-deals__product new-deals__product_active"
             style={updateSliderBackgrounds(index)}>
          <Link to={`/product-card-desktop/${currentProduct && currentProduct.id}`}/>
          <FavoriteHeart  id={currentProduct && currentProduct.id}>
            {(handleClick, classNameEnd) =>
              <div className={`new-deals__product_favorite${classNameEnd}`}
                   onClick={handleClick}/>
            }
          </FavoriteHeart>
        </div>
        <div className="new-deals__product new-deals__product_last"
             style={updateSliderBackgrounds(index + 1)}>
          <Link to={`/product-card-desktop/${nextProduct && nextProduct.id}`}/>
        </div>
        <div className="new-deals__arrow new-deals__arrow_right arrow"
             onClick={handleArrowClick}>
        </div>
      </div>
      <div className="new-deals__product-info">
        <Link to="product-card-desktop" className="h3">{currentProduct && currentProduct.title}</Link>
        <p>Производитель:&nbsp;
          <span>{currentProduct && currentProduct.brand}</span>
        </p>
        <h3 className="h3">{currentProduct && currentProduct.price.toLocaleString('ru-RU')} ₽</h3>
      </div>
    </Fragment>
  )
};

export default withSlider(FeaturedSlider)
